import { Injectable } from '@angular/core';
import {Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions} from '@angular/http';

import { API_ENDPOINTS } from '../configuration/api-endpoints';

import { StorageService } from './storage.service';
import { EncryptionService } from './encryption.service';
import { PopupService } from './pop-up.service';
import { ErrorService } from './error.service';
import { PageNavigationService } from './page-navigation.service';

@Injectable()
export class AuthService{

    vForceChangePassData : {
        email: string,
        temporary_password: string,
        new_password: string,
        retype_new_password: string,
        security_question: string,
        security_answer: string
    }

    vLoadingStatus: boolean;
    randomoff:number;
    vPaymentSessionId:any;
    

    constructor(
        private _popupService: PopupService,
        private _http: Http,
        private _errorService: ErrorService,
        private _storageService: StorageService,
        private _encryptionService: EncryptionService,
        private _pageNavigationService: PageNavigationService
    ) {
        this.vLoadingStatus = false;
        this.vPaymentSessionId = '';
    }

    getLoadingStatus(){
        return this.vLoadingStatus;
    }

    resetForceChangePassData(){
        this.vForceChangePassData = {
            email: '',
            temporary_password: '',
            new_password: '',
            retype_new_password: '',
            security_question: '',
            security_answer: ''
        }
    }

    resetError() {
        this._errorService.resetErrorFlag();
        this._errorService.resetError();
        this._errorService.resetBackEndError();
    }

    logout() {
        /* this.resetError();
         this._http.get('/api/user/logout').subscribe(
             (response) => {
                 this._storageService.clearAll();
                 this._storageService.clearAllSession();
                 this._pageNavigationService.navigate(['login']);
             },
            (error) => {
                 let vErrorData = error.json();
                 console.log(vErrorData);
                 this._errorService.setErrorFlag(true);
                 this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
             }
         );*/

         let xData = {
            randomoff: 1
        }        
        this._storageService.clearAll();
        this._storageService.clearAllSession();
        this._pageNavigationService.navigate(['login']);
        this._http.post(API_ENDPOINTS.AUTH.UNIQUE, xData).subscribe(
            (response) => {
            },
            (error) => {
            }
        );
    }

    isDisableChangePasswordInput(){
        if(this.vForceChangePassData.security_question === undefined || this.vForceChangePassData.security_question === ""){
            return true;
        } else if(this.vForceChangePassData.security_answer === undefined || this.vForceChangePassData.security_answer === ""){
            return true;
        } else if(this.vForceChangePassData.temporary_password === undefined || this.vForceChangePassData.temporary_password === ""){
            return true;
        } else if(this.vForceChangePassData.new_password === undefined || this.vForceChangePassData.new_password === ""){
            return true;
        } else if(this.vForceChangePassData.retype_new_password === undefined || this.vForceChangePassData.retype_new_password === ""){
            return true;
        } else if(this.vForceChangePassData.new_password.length < 8){
            return true;
        }
        return false;
    }

    checkLogin(pEmail: string, pPassword: string) {
        this.resetError();

        if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(pEmail)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('email', 'Your email address is invalid.');
            return;
        }


        // let xData1 = {
        //     plant_request_id: "06004"
        // }       

        // this._http.post(API_ENDPOINTS.AUTH.NODE_TEST, xData1).subscribe();

        let xData = {
            email: pEmail,
            password: pPassword
        }
        
        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.AUTH.LOGIN, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);

                this._storageService.setToken('accessToken', vResponseData.data.accessToken,true);
                this._storageService.setToken('idToken', vResponseData.data.idToken,true);
                this._storageService.setToken('refreshToken', vResponseData.data.refreshToken,true);

                var accesses = vResponseData.data.accesses;
                var accessesStr = JSON.stringify(accesses);
                this._storageService.setLocalItem('access', accessesStr);

                var decodedIdToken = this._encryptionService.decodeToken(vResponseData.data.idToken);
                var vPersonalData = {
                    userid: decodedIdToken["custom:user_record_id"],
                    username: decodedIdToken["cognito:username"],
                    name: decodedIdToken.name
                }
                var strPersonalData = JSON.stringify(vPersonalData);
                this._storageService.setLocalItem('personalData', strPersonalData);

                this.checkSecurityQuestion(pEmail,accesses);
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData:any = error;
                this._errorService.setErrorFlag(true);

                if(vErrorData.code === 901){
                    this._storageService.setSessionItem('temporaryEmail', pEmail);
                    this._pageNavigationService.navigate(['registration-confirmation']);
                } else if(vErrorData.code === 51012){
                    this._storageService.setSessionItem('temporaryEmail', pEmail);
                    this._pageNavigationService.navigate(['change-password']);
                } else{
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    checkSecurityQuestion(pEmail: string,pAccesses: Array<string>){
        this.resetError();
        
        this.vLoadingStatus = true;
        this._http.get(API_ENDPOINTS.ACCOUNT.GET_SECURITY_QUESTION + '?email=' + pEmail).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);
                
                if(this.actionChecking('MANINU', pAccesses) && this.actionChecking('MANEXU', pAccesses)&& !(this.actionChecking('MANPL', pAccesses))){ // ADMN //Modified by Kowsalya: 28/07/2020
                    this._pageNavigationService.navigate(['admin-report']);
                }
                else if (this.actionChecking('MANPL', pAccesses) && !(this.actionChecking('MANINU', pAccesses)) && !(this.actionChecking('MANEXU', pAccesses))) //Kowsalya
                {
                    this._pageNavigationService.navigate(['plantmap-admin-all']);
                }
                else
                {
                    this._pageNavigationService.navigate(['home']);
                }

            },
            (error) => {
                this.vLoadingStatus = false;
                let vErrorData = error;
                console.log(vErrorData);
                this._errorService.setErrorFlag(true);
                if(vErrorData.code === 51016){
                    this._storageService.setSessionItem('temporaryEmail', pEmail);
                    this._pageNavigationService.navigate(['change-password']);
                } else {
                    this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
                }
            }
        );
    }

    changePassword(){
        this.resetError();

        if(this.vForceChangePassData.new_password !== this.vForceChangePassData.retype_new_password){
            this._errorService.setErrorFlag(true);
            //this._errorService.setErrorStatusAndMessage('retypePassword', 'The password are not match');
            this._errorService.setErrorStatusAndMessage('retypePassword', 'The new password and confirm new password does not match.');
            return;
        }

        this.vForceChangePassData.email = this._storageService.getSessionItem('temporaryEmail');
        this.vLoadingStatus = true;
        let isForceChangePassword = this._storageService.getLocalItem('accessToken') === null;
        if(isForceChangePassword){
            this.forceChangePassword();
        } else {
            this.forceResetChangePassword();
        }
        
    }

    forceChangePassword(){
        this._http.post(API_ENDPOINTS.AUTH.FORCE_CHANGE_PASSWORD, this.vForceChangePassData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);

                this._storageService.setToken('accessToken', vResponseData.data.accessToken,true);
                this._storageService.setToken('idToken', vResponseData.data.idToken,true);
                this._storageService.setToken('refreshToken', vResponseData.data.refreshToken,true);

                var accesses = vResponseData.data.accesses;
                var accessesStr = JSON.stringify(accesses);
                this._storageService.setLocalItem('access', accessesStr);

                var decodedIdToken = this._encryptionService.decodeToken(vResponseData.data.idToken);
                var vPersonalData = {
                    userid: decodedIdToken["custom:user_record_id"],
                    username: decodedIdToken["cognito:username"],
                    name: decodedIdToken.name
                }
                var strPersonalData = JSON.stringify(vPersonalData);
                this._storageService.setLocalItem('personalData', strPersonalData);

                this._popupService.openLinkConfirmationPopup('Notice', 'Your account has been successfully updated', '', true,
                 false, 'Go To Main Page', 'home');
                this._storageService.removeSessionItem('temporaryEmail');
            },

            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    forceResetChangePassword(){
        let xData = {
            previous_password: this.vForceChangePassData.temporary_password,
            proposed_password: this.vForceChangePassData.new_password
        }

        this._http.post(API_ENDPOINTS.ACCOUNT.CHANGE_PASSWORD, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData:any = response;
                console.log(vResponseData);

                this.createSecurityQuestion();
            },

            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    createSecurityQuestion(){
        let xData = {
            email: this.vForceChangePassData.email,
            security_question: this.vForceChangePassData.security_question,
            security_answer: this.vForceChangePassData.security_answer
        }
        
        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.ACCOUNT.CREATE_SECURITY_QUESTIION, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                var vNav = 'home';
                this._popupService.openLinkConfirmationPopup('Notice', 'Your account has been successfully updated', '', true,
                false, 'Go To Main Page', vNav);
                this._storageService.removeSessionItem('temporaryEmail');
            },
            (error) => {
                this.vLoadingStatus = false;
                let vErrorData = error;
                this._errorService.setErrorFlag(true);
                this._errorService.setBackEndError(vErrorData.code, vErrorData.desc);
            }
        );
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }

    getPaymentSessionValue() {
        return this.vPaymentSessionId;
    }

 
    
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/auth.service.ts